import React, { useContext, useMemo } from 'react';
import { Checkbox, Grid, FormControlLabel } from '@mui/material';
import { ChartingCodeContext } from 'pages/Test/lib/chartingCodeContext';
import createLabel from 'pages/Test/lib/createLabel';




export const CheckboxInput = ({ fieldConfig, value }) => {
	const { setValue } = useContext(ChartingCodeContext);

	return (
		<Grid item xs={fieldConfig.grid}>
			<FormControlLabel
				labelPlacement="top"
				control={<Checkbox
					checked={value}
					onChange={e => setValue(fieldConfig.valueName, e.target.checked)}
				/>}
				label={createLabel(fieldConfig)}
			/>
		</Grid>
	);
};

export default CheckboxInput;
